import { render } from "./AppTitle.vue?vue&type=template&id=66a8838c"
import script from "./AppTitle.vue?vue&type=script&lang=js"
export * from "./AppTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__